export class UpdateEvent<T=string,ELEMENT=any> {
    private _nativeEvent:Event
    private _value:T|undefined|null
    private _target:ELEMENT|undefined|null
    constructor(nativeEvent:Event, value:T|undefined|null, target:ELEMENT|undefined|null) {
        this._nativeEvent = nativeEvent
        this._value = value
        this._target = target
    }

    get nativeEvent(){return this._nativeEvent}
    get value(){return this._value}
    get target(){return this._target}

    preventDefault(){ this._nativeEvent.preventDefault(); return this }
    stopPropagation(){ this._nativeEvent.stopPropagation(); return this }
}
export type TUpdateEventHandler<T=string,ELEMENT=any> = (e:UpdateEvent<T,ELEMENT>) => void